<template>
    <!--
        Visibility for checkout step2 is set to hidden when error is displayed
        because in some cases step2 block is bigger than error popup and that breaks design
    -->
    <div
        class="checkout__step-2"
        style="display: block"
        :style="{ display: popup.errorCode !== null ? 'none' : 'block' }"
        data-test="checkout-step-2">
        <div class="checkout__step-2--landscape">
            <div class="checkout__cart">
                <slot name="header"></slot>
            </div>

            <slot name="account-info"></slot>

            <slot name="content"></slot>

            <div class="checkout__payment-block">
                <div class="checkout__payment-option" :class="{ 'checkout__payment-option--rtl': isRTL }">
                    <portal-target name="credit-card-payment-tab" @change="IECardImagesFix"></portal-target>

                    <slot name="paypal"></slot>

                    <slot name="apple-pay"></slot>
                </div>
                <hr class="checkout__payment-option--seperator" />

                <slot name="credit-card"></slot>
            </div>

            <portal-target name="credit-card-payment-submit"></portal-target>

            <p class="checkout__guarantee">{{ $t('checkout.guarantee') }}</p>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import CreditCardPayment from './payment_handlers/CreditCardPayment.vue';
import PaypalPayment from './payment_handlers/PaypalPayment.vue';

export default {
    components: {
        CreditCardPayment,
        PaypalPayment,
    },
    computed: {
        ...mapState(['processingCheckout', 'popup']),
        isRTL() {
            return window.App.isRTL;
        }
    },
    watch: {
        // Have to be here because Layout component is used by both - checkout and update payment method
        processingCheckout: function () {
            // Scroll checkout step 2 to top to see procesiig popup on smaller phones
            if (this.processingCheckout) {
                document.getElementsByClassName('checkout__content')[0].scrollTop = 50;
            }
        },
    },
    methods: {
        // IE11 fix for checkout credit cards images not loading
        IECardImagesFix() {
            const isIE11 = /Trident.*rv[ :]*11\./.test(navigator.userAgent);
            if (isIE11) {
                $('.lazy').each(function () {
                    var image = $(this);
                    image.show();
                    image.attr('src', image.data('src'));
                });
            }
        },
    },
};
</script>
